module.exports = __webpack_public_path__ + "static/media/dtj-mockup-4.b3c4e028.jpg";